// GhostLayout Core - Types, Registry, Utilities

// ========================
// BLUEPRINT REGISTRY
// ========================

let registry = {};

export function registerBlueprints(blueprints) {
  registry = { ...registry, ...blueprints };
}

export function getBlueprints(name) {
  return registry[name];
}

export function getAllBlueprints() {
  return registry;
}

export function clearRegistry() {
  registry = {};
}

// ========================
// RESPONSIVE UTILITIES
// ========================

export function getResponsiveBlueprints(breakpoints, currentWidth) {
  const bps = Object.keys(breakpoints)
    .map(Number)
    .sort((a, b) => a - b);

  let selectedBreakpoint = bps[0];
  for (const bp of bps) {
    if (currentWidth >= bp) {
      selectedBreakpoint = bp;
    } else {
      break;
    }
  }

  return breakpoints[selectedBreakpoint]?.blueprints || [];
}

export function calculateAbsolutePosition(blueprint, containerWidth) {
  return {
    left: (blueprint.x / 100) * containerWidth,
    top: blueprint.y,
    width: (blueprint.w / 100) * containerWidth,
    height: blueprint.h,
    borderRadius: blueprint.r || 0,
  };
}
